// src/utils/formatVendorType.ts

export const formatVendorType = (type: 'individual' | 'sole_proprietor' | 'llc' | 'corporation' | 'partnership' | 'non_profit' | ''): string => {
    const types: Record<string, string> = {
        individual: 'Individual',
        sole_proprietor: 'Sole Proprietor',
        llc: 'LLC',
        corporation: 'Corporation',
        partnership: 'Partnership',
        non_profit: 'Non-Profit Organization',
    };
    return types[type] || type || 'Not specified';
};